import PropTypes from 'prop-types';
import { Box, Card, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

// ----------------------------------------------------------------------

const StyledImg = styled('img')({
  top: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
  transition: 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
});

ShopProductCard.propTypes = {
  kecamatans: PropTypes.object,
};

export default function ShopProductCard({ kecamatans }) {
  const BACKEND_API = process.env.REACT_APP_BE;
  const { image2, kecamatan } = kecamatans;

  return (
    <Card
      component="a"
      href={`/detail-kecamatan/${kecamatan}`}
      elevation={0}
      sx={{
        textDecoration: 'none',
        display: 'block',
        borderRadius: '20px',
        overflow: 'hidden',
        border: '1px solid rgba(0,0,0,0.07)',
        boxShadow: '0 4px 24px rgba(0,0,0,0.07)',
        transition: 'all 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
        cursor: 'pointer',
        '&:hover': {
          transform: 'translateY(-8px)',
          boxShadow: '0 20px 50px rgba(184,92,44,0.18)',
          borderColor: 'rgba(184,92,44,0.2)',
          '& img': {
            transform: 'scale(1.08)',
          },
          '& .arrow-icon': {
            transform: 'translateX(4px)',
          },
        },
      }}
    >
      {/* Image Area */}
      <Box sx={{ pt: '75%', position: 'relative', overflow: 'hidden', bgcolor: '#f5f0eb' }}>
        <StyledImg alt={kecamatan} src={`${BACKEND_API}${image2}`} />
        {/* Overlay */}
        <Box sx={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(to top, rgba(26,26,46,0.7) 0%, rgba(0,0,0,0.1) 60%, transparent 100%)',
        }} />
        {/* Badge */}
        <Box sx={{
          position: 'absolute',
          top: 14, left: 14,
          background: 'rgba(184,92,44,0.9)',
          backdropFilter: 'blur(6px)',
          borderRadius: '50px',
          px: 1.5, py: 0.4,
        }}>
          <Typography sx={{ color: '#fff', fontSize: '11px', fontWeight: 700 }}>
            Kecamatan
          </Typography>
        </Box>
      </Box>

      {/* Content */}
      <Box sx={{ p: 2.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
          <LocationOnOutlinedIcon sx={{ fontSize: 15, color: '#B85C2C' }} />
          <Typography sx={{
            fontSize: '11px',
            color: '#B85C2C',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
          }}>
            Lokasi
          </Typography>
        </Box>
        <Typography sx={{
          fontWeight: 800,
          fontSize: '17px',
          color: '#1A1A2E',
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          mb: 1.5,
        }}>
          {kecamatan}
        </Typography>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          color: '#B85C2C',
          fontWeight: 700,
          fontSize: '13px',
          fontFamily: "'Plus Jakarta Sans', sans-serif",
        }}>
          Jelajahi
          <ArrowForwardIcon
            className="arrow-icon"
            sx={{ fontSize: 15, transition: 'transform 0.25s ease' }}
          />
        </Box>
      </Box>
    </Card>
  );
}
